'use strict';

function Message (resource, utils) {
  'ngInject';

  return resource({
    url: function () {
      return utils.getApiUrlV2('/messages/' + this._constructorOptions.getUserId() + '/' + this._constructorOptions.getConversationId());
    },
    comparator: '-sentAt'
  });
}

export default Message;



// WEBPACK FOOTER //
// ./app/src/resources/message.js